<template>
    <v-card rounded="lg" outlined style="overflow: unset;" :class="{ 'employment-item--list': list }" :color="isChecked ? 'primary lighten-5' : undefined">
        <div class="pa-20 pa-md-24">
            <v-row align="center" class="row--x-large">
                <v-col v-if="!list" cols="12" lg="auto" class="mb-10 mb-lg-0">
                    <v-btn text class="select-btn" @click="toggle">
                        <v-simple-checkbox :value="isChecked" hide-details class="v-input--checkbox--lg" color="primary" @click.stop.capture="toggle" />
                    </v-btn>
                </v-col>
                <v-col cols="12" lg="auto">
                    <v-row align="center">
                        <v-col cols="auto">
                            <v-avatar color="grey">
                                <v-img :src="value?.resume?.profile?.url">
                                    <v-fade-transition>
                                        <v-icon v-show="!value?.resume?.profile?.url" color="white">mdi-account</v-icon>
                                    </v-fade-transition>
                                </v-img>
                            </v-avatar>
                        </v-col>
                        <v-col cols="auto">
                            <v-row no-gutters align="center">
                                <v-col cols="auto">
                                    <h5 class="page-text--lg font-weight-medium pr-4 pr-lg-0 min-w-lg-80px">
                                        {{ value?.resume?.personalInformation?.name }}
                                    </h5>
                                </v-col>
                                <v-col cols="auto">
                                    <p class="page-text grey-9--text">({{ value?.resume?.personalInformation?.genderText }}, {{ value?.resume?.personalInformation?.age }})</p>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" lg="" class="employment-item__center">
                    <ul class="dot-texts">
                        <template v-for="text in cardTextList">
                            <li class="dot-text page-text grey-6--text ellip" :key="text">
                                <span> · {{ text }} </span>
                            </li>
                        </template>
                    </ul>
                </v-col>
                <v-col cols="12" lg="auto">
                    <v-row class="row--small">
                        <v-col lg="auto">
                            <application-view v-bind="{ value, recruitment }" @input="(item) => $emit('input', item)">
                                <template #activator="{ attrs, on }">
                                    <v-btn small outlined block color="primary" v-bind="attrs" v-on="on">
                                        <span>지원자 정보</span>
                                    </v-btn>
                                </template>
                            </application-view>
                        </v-col>
                        <v-col v-if="list" lg="auto">
                            <v-btn small outlined block color="grey-d" @click="toggle">
                                <span class="grey-6--text">취소</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>

<script>
import { attrs_input } from "@/assets/variables";
import { EDUCATION_ATTENDING_STATUSES, EDUCATION_INSTITUTION_TYPES } from "@/assets/variables";

import ApplicationView from "@/components/dashboard/company/application/application-view.vue";

export default {
    components: {
        ApplicationView,
    },
    props: {
        list: Boolean,
        value: { type: Object, default: () => ({}) }, // application
        recruitment: { type: Object, default: () => ({}) },
        applications: { type: Array, default: () => [] },
    },
    data: () => ({
        attrs_input,
    }),
    computed: {
        isChecked() {
            return this.applications.some((item) => item._id == this.value._id);
        },
        area() {
            let { address1, address2 } = this.value?.resume?.personalInformation?.residence || {};
            return `${address1} ${address2}`;
        },
        education() {
            let { institutionType, attendingStatus } = this.value?.resume?.education || {};

            let education = "";
            if (institutionType) education += `${EDUCATION_INSTITUTION_TYPES[institutionType]?.text || ""} `;
            if (attendingStatus) education += `${EDUCATION_ATTENDING_STATUSES[attendingStatus]?.text || ""} `;
            return education.trim();
        },
        cardTextList() {
            return [this.value?.resume?.personalInformation?.phone, this.area, this.education];
        },
    },
    methods: {
        toggle() {
            let event = this.isChecked ? "pull" : "push";
            this.$emit(event, this.value);
        },
    },
};
</script>

<style lang="scss" scoped>
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .employment-item {
        &__center {
            max-width: calc(100% - 514px);
        }
        &--list {
            .employment-item__center {
                max-width: calc(100% - 492px);
            }
        }
    }
}
@media (min-width: 1200px) {
}

.select-btn {
    min-width: unset;
    height: unset;
    padding: 0;

    &::before {
        display: none;
    }
}
</style>
